import type { UseMutationResult } from '@tanstack/react-query';
import { useMemo } from 'react';

export function useMutationMemoized<TData = unknown, TError = unknown, TVariables = unknown, TContext = unknown>(
  mutation: UseMutationResult<TData, TError, TVariables, TContext>
) {
  const memoized = useMemo(
    () => ({
      data: mutation.data,
      error: mutation.error,
      status: mutation.status,
      mutate: mutation.mutate,
      mutateAsync: mutation.mutateAsync,
      context: mutation.context,
      failureCount: mutation.failureCount,
      failureReason: mutation.failureReason,
      isError: mutation.isError,
      isIdle: mutation.isIdle,
      isPaused: mutation.isPaused,
      isPending: mutation.isPending,
      isSuccess: mutation.isSuccess,
      reset: mutation.reset,
      submittedAt: mutation.submittedAt,
      variables: mutation.variables,
    }),
    [
      mutation.data,
      mutation.error,
      mutation.status,
      mutation.mutate,
      mutation.mutateAsync,
      mutation.context,
      mutation.failureCount,
      mutation.failureReason,
      mutation.isError,
      mutation.isIdle,
      mutation.isPaused,
      mutation.isPending,
      mutation.isSuccess,
      mutation.reset,
      mutation.submittedAt,
      mutation.variables,
    ]
  );

  return memoized as typeof mutation;
}
